import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import {
  PROMOCODE_LIST,
  DELETE_PROMOCODE,
  PROMOCODE_STATUS_CHANGE,
  PROMOTION_LIST,
  DELETE_PROMOTION,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";

// img
import u1 from "../../../Assets/images/authbg.png";
import { Link } from "react-router-dom";
// import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";

const PromotionList = () => {
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: PROMOTION_LIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: "Name",
      accessor: "promotionName",
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key) => {
        return (
          <>
            <p
              style={{
                backgroundColor:
                  item?.status === "active" ? "lightgreen" : "lightcoral",
                borderRadius: "12px",
                padding: "2px 2px",
                width: "50%",
                textAlign: "center",
              }}
            >
              {item?.status === "active" ? "Active" : "Inactive"}
            </p>
          </>
        );
      },
    },

    {
      head: "Created At",
      accessor: "start_date",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item?.date_created_utc).format("YYYY-MM-DD")}</p>
          </>
        );
      },
    },

    {
      head: "Action",
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/edit-promotion/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);
  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_PROMOTION({ _id: deleteModel.dumpId }))
        }
      />
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Manage Promotion
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/add-promotion"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    Add New
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PromotionList;
